import logger from "../utils/logger";

export const formatDataforGenericSelect = (data = []) => {

  logger.debug('formatDataforGenericSelect: ', data)

  const normalizedData = Array.isArray(data) ? data : [data];

  logger.debug('formatDataforGenericSelect data:', normalizedData)

  return normalizedData.map(i => {

    const hasDescription = i.description && i.description.trim().length > 0;

    if (i.name && hasDescription) {

      const withDescription = {
        value: Number(i.id),              // SIEMPRE number
        label: `${i.name} (${i.description})`,
      }

      logger.debug('withDescription format: ', withDescription)

      return withDescription;
    }


    const withOutDescription = {
      value: Number(i.id),               // SIEMPRE number
      label: i.name || i.description || i.prefix || "",
    }

    logger.debug('withOutDescription format: ', withOutDescription)

    return withOutDescription

  });
};


